import { NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { CpsIndex } from '@cs-cms/types';

export interface IndexDropdownOption {
  text: string;
  value: number;
  dataItem: CpsIndex;
}

export function mapIndexesToDropdownOptions(indexes: CpsIndex[] | undefined): IndexDropdownOption[] {
  return (
    indexes?.map(index => ({
      text: index.displayName || index.name,
      value: index.id,
      dataItem: index
    })) ?? []
  );
}

export function findSelectedIndexDropdownOption(
  selectedIndex: CpsIndex | null,
  indexOptions: IndexDropdownOption[]
): IndexDropdownOption | null {
  if (!selectedIndex || indexOptions.length === 0) {
    return null;
  }

  return indexOptions.find(option => option.value === selectedIndex.id) ?? null;
}

function isIndexDropdownOption(value: unknown): value is IndexDropdownOption {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return 'dataItem' in value;
}

export function getIndexFromDropdownChange(event: DropDownListChangeEvent): CpsIndex | null {
  const selectedOption = event.target.value;

  if (!isIndexDropdownOption(selectedOption)) {
    return null;
  }

  return selectedOption.dataItem;
}

export function clampLimitValue(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export function getLimitFromNumericChange(
  event: NumericTextBoxChangeEvent,
  min: number,
  max: number
): number | null {
  const newValue = event.target.value;

  if (newValue === null) {
    return newValue;
  }

  return clampLimitValue(newValue, min, max);
}

export function isConfigurationSaveDisabled(params: {
  hasSelectedIndex: boolean;
  hasUnsavedChanges: boolean;
  isLoading: boolean;
  isSaving: boolean;
  canEdit: boolean;
}): boolean {
  return (
    !params.hasSelectedIndex ||
    !params.hasUnsavedChanges ||
    params.isLoading ||
    params.isSaving ||
    !params.canEdit
  );
}
